import styled, { css, keyframes } from 'styled-components'

const flashingAnimation = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.5;
  }
`

export const StyledLoadingOverlay = styled.div<{ isLoading?: boolean }>`
  ${({ isLoading }) => {
    return (
      isLoading &&
      css`
        animation: ${flashingAnimation} 1.5s infinite;
        pointer-events: none;
      `
    )
  }}
`
